import { produce } from 'immer'
import { AnyAction } from 'redux'

import { history, isPast } from '~/helpers'

import * as types from './constants'
import { INITIAL_STATE, defaultValues } from './defaultValues'
import reducerCases from './reducerCases'

export default function chats(state = INITIAL_STATE, action: AnyAction) {
  return produce(state, draft => {
    switch (action.type) {
      case types.SET_FULL_SCREEN: {
        draft.fullScreen = action.payload
        break
      }

      /**
       * CHATS
       */

      case types.SET_CHATS_ORDER_BY:
        draft.loadingChats = true
        draft.masterLoadingChats = true
        draft.sortChatsBy = action.payload
        break

      // Caso usado para ligarmos o loading enquanto o debounce segura a request
      case types.SET_LOADING_CHATS:
        draft.loadingChats = action.payload
        break

      // Set auto refresh
      case types.TOGGLE_AUTO_REFRESH:
        draft.autoRefresh = action.payload.status
        break

      // Get Chats
      case `${types.GET_CHATS}_PENDING`:
        draft.loadingChats = true
        draft.shouldRefreshChats = false

        break

      case `${types.GET_CHATS}_FULFILLED`: {
        const openChat = draft.selectedChat

        const {
          data: chats,
          currentPage,
          pages,
          total,
          count = defaultValues.chatsCount
        } = action.payload as GetChatsResponse

        draft.chats = chats
        draft.chatsCount = count || defaultValues.chatsCount

        /**
         * Handle Tabs [ DOC ]
         * Manipulando para alternar de aba de acordo com o resultado
         * Se não tem mensagens vinculada, joga pra fila
         * && Se não tem mensagem na fila, joga pra todas
         */
        const emptyInbox = count.in_contact <= 0
        const emptyMainInbox = count.waiting_contact <= 0

        if (
          draft.selectedStatus === 'waiting_contact' ||
          draft.selectedStatus === 'in_contact'
        ) {
          if (emptyInbox && !emptyMainInbox) {
            draft.selectedStatus = 'waiting_contact'
          }

          if (emptyInbox && emptyMainInbox) {
            draft.selectedStatus = 'available'
          }
        }
        /**
         * Handle Tabs - Final
         */

        draft.currentPage = Number(currentPage)
        draft.pages = pages
        draft.chatsLength = total || action.payload.length

        draft.loadingChats = false
        draft.masterLoadingChats = false
        draft.loading = false

        if (openChat) {
          const selectedChat = chats.findIndex(
            item => item.chatId === openChat.chatId
          )

          if (!action.payload.data.length) {
            draft.selectedChat = null
            history.push('/chats')
          } else {
            selectedChat > -1 && (draft.selectedChat = chats[selectedChat])
          }
        }

        break
      }

      case `${types.GET_CHATS}_REJECTED`:
        draft.loadingChats = false
        draft.masterLoadingChats = false
        draft.error = action.payload
        break

      // Get Chat
      case `${types.GET_CHAT}_PENDING`:
        draft.loadingChats = true
        draft.shouldRefreshChats = false

        break

      case `${types.GET_CHAT}_FULFILLED`: {
        // Lógica igual do GET CHATS

        const openChat = draft.selectedChat

        const chats = action.payload.data
        const { currentPage, pages, total } = action.payload

        draft.chats = chats

        draft.currentPage = Number(currentPage)
        draft.pages = pages
        draft.chatsLength = total || action.payload.length

        draft.loadingChats = false
        draft.masterLoadingChats = false
        draft.loading = false

        if (openChat) {
          const selectedChat = chats.findIndex(
            item => item.chatId === openChat.chatId
          )

          selectedChat > -1 && (draft.selectedChat = chats[selectedChat])
        }
        // Fim - Lógica igual do GET CHATS

        const chat = chats?.[0]

        if (chat) {
          draft.customerId = chat.customerId

          const isArhcived = !!chat.session && isPast(chat.session.expireAt)
          const isFinished = chat?.session?.finishedAt

          if (isArhcived) {
            draft.selectedStatus = 'finished'
            const { session, ...coreChat } = chat

            draft.selectedChat = coreChat
          }

          if (!isArhcived && isFinished) {
            draft.selectedStatus = 'finished'
            draft.selectedChat = chat
          }
        }

        break
      }

      case `${types.GET_CHAT}_REJECTED`:
        draft.loadingChats = false
        draft.masterLoadingChats = false
        draft.error = action.payload
        break

      // Get More Chats
      case `${types.GET_MORE_CHATS}_PENDING`:
        draft.loadingChats = true
        break

      case `${types.GET_MORE_CHATS}_FULFILLED`: {
        const openChat = draft.selectedChat

        const chats = action.payload.data
        const { currentPage, pages, total } = action.payload

        draft.chats = [...draft.chats, ...chats]

        draft.currentPage = Number(currentPage)
        draft.pages = pages
        draft.chatsLength = total || action.payload.length

        draft.loading = false
        draft.loadingChats = false
        draft.masterLoadingChats = false
        draft.shouldRefreshChats = false

        if (openChat) {
          const selectedChat = chats.findIndex(
            item => item.chatId === openChat.chatId
          )

          selectedChat > -1 && (draft.selectedChat = chats[selectedChat])
        }

        break
      }

      case `${types.GET_MORE_CHATS}_REJECTED`:
        draft.loadingChats = false
        draft.masterLoadingChats = false
        draft.error = action.payload
        break

      /**
       * Get initial messages
       */
      case `${types.GET_MESSAGES_INITIAL}_PENDING`: {
        draft.loading = true
        draft.messages = []
        break
      }

      case `${types.GET_MESSAGES_INITIAL}_FULFILLED`: {
        const { data, currentPage, pages, total } = action.payload

        const newMessages = [...data]

        draft.messages = [...newMessages]

        draft.messagesCurrentPage = Number(currentPage)
        draft.messagesPages = pages
        draft.messagesTotal = total
        draft.loading = false
        break
      }

      case `${types.GET_MESSAGES_INITIAL}_REJECTED`:
        draft.loading = false
        draft.error = action.payload
        break

      /**
       * Get more messages
       */
      case `${types.GET_MESSAGES_MORE}_PENDING`: {
        draft.loading = true
        break
      }

      case `${types.GET_MESSAGES_MORE}_FULFILLED`: {
        const { data, currentPage, pages, total } = action.payload

        const newMessages = [...data]

        draft.messages = [...draft.messages, ...newMessages]

        draft.messagesCurrentPage = currentPage
        draft.messagesPages = pages
        draft.messagesTotal = total
        draft.loading = false
        break
      }

      case `${types.GET_MESSAGES_MORE}_REJECTED`:
        draft.loading = false
        draft.error = action.payload
        break

      /**
       * Set selected chat
       */
      case types.SET_SELECTED_CHAT: {
        draft.selectedChat = action.payload.selectedChat
        draft.customerId = action.payload.selectedChat?.customerId || null
        draft.orderOpen = {}
        break
      }

      /**
       * Cleat selected chat
       */
      case types.CLEAR_SELECTED_CHAT: {
        draft.selectedChat = null
        draft.customerId = null
        draft.orderOpen = {}
        draft.chatIdByUrl = null
        draft.fullScreen = false
        break
      }

      // Set id URL
      case types.SET_ID_URL: {
        draft.chatIdByUrl = action.payload.id
        draft.loading = true
        break
      }

      // Toogle panel customer status
      case types.TOGGLE_PANEL_CUSTOMER: {
        draft.templatePanelHistory = false
        draft.templatesPanelOpen = false
        draft.tagsPanelOpen = false
        draft.shoppingCartPanelOpen = false
        draft.slidingPanelIsOpen = !draft.customerPanelOpen
        draft.customerPanelOpen = !draft.customerPanelOpen
        break
      }

      //
      case types.TOGGLE_PANEL_HISTORY: {
        draft.tagsPanelOpen = false
        draft.shoppingCartPanelOpen = false
        draft.customerPanelOpen = false

        draft.slidingPanelIsOpen = !draft.templatePanelHistory
        draft.templatePanelHistory = !draft.templatePanelHistory
        break
      }

      // Toogle panel templates status
      case types.TOGGLE_PANEL_TEMPLATES: {
        draft.templatePanelHistory = false
        draft.customerPanelOpen = false
        draft.tagsPanelOpen = false
        draft.shoppingCartPanelOpen = false
        draft.slidingPanelIsOpen = !draft.templatesPanelOpen
        draft.templatesPanelOpen = !draft.templatesPanelOpen
        break
      }

      // Toogle panel shopping cart
      case types.TOGGLE_PANEL_SHOPPING_CART: {
        draft.templatePanelHistory = false
        draft.customerPanelOpen = !draft.customerId
        draft.tagsPanelOpen = false
        draft.templatesPanelOpen = false
        draft.slidingPanelIsOpen = !draft.shoppingCartPanelOpen
        draft.shoppingCartPanelOpen = !draft.shoppingCartPanelOpen
        break
      }

      // Toogle panel templates status
      case types.TOGGLE_PANEL_TAGS: {
        // Reset chat list edit mode
        draft.templatePanelHistory = false
        draft.selectChatsMode = false
        draft.chatsSelectedToEdit = []
        draft.selectedTags = []
        // Set panels
        draft.customerPanelOpen = false
        draft.templatesPanelOpen = false
        draft.shoppingCartPanelOpen = false
        draft.slidingPanelIsOpen = !draft.tagsPanelOpen
        draft.tagsPanelOpen = !draft.tagsPanelOpen
        break
      }

      // Close all panels
      case types.CLOSE_SIDE_PANELS: {
        draft.templatePanelHistory = false
        draft.customerPanelOpen = false
        draft.templatesPanelOpen = false
        draft.tagsPanelOpen = false
        draft.slidingPanelIsOpen = false
        draft.shoppingCartPanelOpen = false
        break
      }

      // Set Chat Menu Open
      case types.SET_CHAT_MENU_OPEN: {
        const { chatId, sessionId, positionParent } = action.payload

        const selectedChats = draft.chats.find(item => item.chatId === chatId)

        const customerNumber = selectedChats?.customerNumber

        const menuIsOpen = chatId !== draft.chatMenuOpen?.chatId
        const addItem = { chatId, sessionId, positionParent, customerNumber }
        const removeItem = {
          chatId: null,
          sessionId: null,
          positionParent,
          customerNumber: null
        }

        const newStatus = menuIsOpen ? addItem : removeItem

        draft.chatMenuOpen = newStatus

        break
      }

      // Toogle mode select chats status
      case types.TOGGLE_SELECT_CHATS_MODE: {
        const { initialChat } = action.payload
        draft.selectChatsMode = !draft.selectChatsMode
        draft.chatMenuOpen = null

        if (initialChat) {
          draft.chatsSelectedToEdit = [initialChat]
        }

        break
      }

      /**
       * LOCATION
       */

      // Toogle mode select chats status
      case types.TOGGLE_EDIT_LOCATIONS_MODE: {
        draft.editLocationMode = !draft.editLocationMode

        if (draft.chatMenuOpen?.chatId) {
          const selectedChats = draft.chats.find(
            item => item.chatId === draft.chatMenuOpen.chatId
          )

          draft.selectedChatToUpdate = selectedChats
        } else {
          draft.selectedChatToUpdate = null
        }

        draft.chatMenuOpen = null

        break
      }

      case `${types.UPDATE_CHAT_CHAT}_PENDING`: {
        draft.updateChatLoading = true

        break
      }

      case `${types.UPDATE_CHAT_CHAT}_FULFILLED`: {
        const updatedChat = action.payload
        const openChat = draft.selectedChat

        const { chats } = draft
        // Atualizando chat correspondente
        const oldChat = chats.findIndex(
          item => item.chatId === updatedChat.chatId
        )

        chats[oldChat] = updatedChat

        // Atualizando informação do chat aberto
        if (openChat?.chatId === updatedChat.chatId) {
          draft.selectedChat = updatedChat
        }

        draft.editLocationMode = false
        draft.selectedChatToUpdate = null
        draft.chatMenuOpen = null
        draft.chats = chats
        draft.updateChatLoading = false
        draft.customerId = updatedChat?.customerId

        break
      }

      case `${types.UPDATE_CHAT_CHAT}_REJECTED`: {
        draft.updateChatLoading = false

        break
      }

      // Update session
      case `${types.UPDATE_SESSION}_PENDING`: {
        draft.updateChatLoading = true

        break
      }
      // UPDATE
      case `${types.UPDATE_SESSION}_FULFILLED`: {
        const updatedSession = action.payload
        const openChat = draft.selectedChat

        const { chats } = draft
        // Atualizando chat correspondente
        const oldChat = chats.findIndex(
          item => item.session.sessionId === updatedSession.sessionId
        )

        chats[oldChat] = {
          ...chats[oldChat],
          session: { ...updatedSession }
        }

        // Atualizando informação do chat aberto
        if (openChat?.session?.sessionId === updatedSession?.sessionId) {
          draft.selectedChat = {
            ...draft.selectedChat,
            session: { ...updatedSession }
          }
        }

        draft.chats = chats

        draft.editLocationMode = false
        draft.selectedChatToUpdate = null
        draft.chatMenuOpen = null
        draft.updateChatLoading = false
        draft.shouldRefreshChats = true

        break
      }

      case `${types.UPDATE_SESSION}_REJECTED`: {
        draft.updateChatLoading = false

        break
      }

      // Clear the selects chats
      case types.CLEAN_SELECTEDS_CHATS: {
        draft.selectChatsMode = false
        draft.chatsSelectedToEdit = []
        draft.selectedTags = []

        break
      }

      // Set setected chat
      case types.SET_SELECTED_CHAT_TO_EDIT: {
        const { chatId, sessionId } = action.payload
        const selectedChats = draft.chatsSelectedToEdit

        const chatsIsSelected = selectedChats.findIndex(
          item => item.chatId === chatId
        )

        if (chatsIsSelected > -1) {
          selectedChats.splice(chatsIsSelected, 1)
          draft.chatsSelectedToEdit = selectedChats

          break
        }

        draft.chatsSelectedToEdit = [...selectedChats, { chatId, sessionId }]

        break
      }

      // Set
      case types.SET_ORDER_OPEN: {
        draft.orderOpen = action.payload.orderOpen
        break
      }

      // Set message status read
      case `${types.SET_MESSAGE_STATUS_READ}_FULFILLED`: {
        draft.shouldRefreshChats = true

        draft.selectedChat = {
          ...draft.selectedChat,
          unreadMessage: false,
          unreadMessageCount: 0
        }

        break
      }

      /**
       * Add new message from socket.io
       */
      case types.ADD_NEW_MESSAGE: {
        const { selectedStatus, selectedChat } = draft

        const newMessage = { ...action.payload.message, createdAt: new Date() }
        const { filteredLocation } = action.payload

        const newMessageIsFilterdLocation =
          newMessage?.locationId === filteredLocation

        const messageIsFromStore = action.payload.message.fromStore

        const { botActive, messageBody, status } = action.payload.message

        const thisChatIsOpen =
          newMessage?.sessionId &&
          selectedChat?.session?.sessionId === newMessage.sessionId

        if (
          messageIsFromStore &&
          status === 'delivered' &&
          messageBody ===
            'Por enquanto, conte-nos mais sobre como podemos te ajudar...'
        ) {
          draft.shouldPlayNewContactNotifications = true
        }

        if (botActive === false && !messageIsFromStore) {
          draft.shouldPlayNotifications = true
        } else {
          draft.shouldPlayNotifications = false
        }

        if (!newMessageIsFilterdLocation) {
          draft.shouldPlayNotifications = false
        }

        /**
         * Handle messages on active chat
         */

        if (!!selectedChat && thisChatIsOpen) {
          const oldMessages = [...draft.messages]

          const { messageBody } = newMessage

          // Start - Checando se tem preview para apagar
          const hasPreview = oldMessages.findIndex(
            message => message.messageBody === messageBody && message.preview
          )

          if (hasPreview > -1) {
            oldMessages.splice(hasPreview, 1)
          }
          // End - Checando se tem preview para apagar

          // Start - Checando se tem mesmo ID
          const hasSameID = oldMessages.findIndex(
            message => message.messageId === newMessage.messageId
          )

          if (hasSameID > -1) {
            oldMessages[hasSameID] = newMessage
            draft.messages = oldMessages
            break
          }
          // End - Checando se tem mesmo ID

          draft.messages = [newMessage, ...oldMessages]
        }

        // Update chats list

        if (selectedStatus === 'in_contact') {
          const currentChats = [...draft.chats]

          const currentChatIndex = currentChats.findIndex(
            item => item.session?.sessionId === newMessage.sessionId
          )

          if (currentChatIndex > -1) {
            const currentChat = currentChats[currentChatIndex]

            currentChats.splice(currentChatIndex, 1)

            const messageIsUnred = () => {
              if (thisChatIsOpen || botActive !== false) return false

              if (messageIsFromStore) return currentChat.unreadMessage

              return true
            }

            const messageCount = () => {
              if (thisChatIsOpen || botActive !== false) return 0

              if (messageIsFromStore) return currentChat.unreadMessageCount

              return (currentChat.unreadMessageCount || 0) + 1
            }

            const updatedChat = {
              ...currentChat,
              lastMessageAt: newMessage.lastMessageAt,
              unreadMessage: messageIsUnred(),
              unreadMessageCount: messageCount(),
              session: {
                ...currentChat.session,
                botActive
              }
            }

            if (draft.sortChatsBy === 'desc') {
              draft.chats = [updatedChat, ...currentChats]
            }

            if (draft.sortChatsBy === 'asc') {
              draft.chats = [...currentChats, updatedChat]
            }
          } else {
            if (filteredLocation) {
              draft.shouldRefreshChats =
                newMessage?.locationId === filteredLocation
              return
            }

            draft.shouldRefreshChats = false
          }
        }

        break
      }

      case types.SET_NOTIFICATIONS_PLAYED: {
        draft.shouldPlayNotifications = false
        draft.shouldPlayNewContactNotifications = false
        break
      }

      // Add new message from preview
      case types.ADD_NEW_MESSAGE_PREVIEW: {
        const newMessage = action.payload.message
        const oldMessages = [...draft.messages]

        draft.messages = [newMessage, ...oldMessages]

        break
      }

      /**
       * TAGS
       */

      // Create tags

      case types.CREATE_TAG_OPTIMISTIC: {
        const newTag = action.payload
        const oldTags = draft.avaiableTags

        draft.avaiableTags = [...oldTags, newTag]

        break
      }

      case `${types.CREATE_TAG}_PENDING`: {
        draft.loadingCreateTag = true
        break
      }

      case `${types.CREATE_TAG}_FULFILLED`: {
        const newTag = action.payload
        const oldTags = draft.avaiableTags

        const filteredldTags = oldTags.filter(tag => !tag.saving)

        draft.avaiableTags = [...filteredldTags, newTag]
        draft.loadingCreateTag = false

        break
      }

      case `${types.CREATE_TAG}_REJECTED`: {
        const oldTags = draft.avaiableTags

        const filteredldTags = oldTags.filter(tag => !tag.saving)

        draft.avaiableTags = [...filteredldTags]
        draft.loadingCreateTag = false

        break
      }

      // Update tags

      case `${types.UPDATE_TAG}_PENDING`: {
        draft.loadingSavingTag = true
        break
      }

      case `${types.UPDATE_TAG}_FULFILLED`: {
        const updatedTag = action.payload
        const oldTags = draft.avaiableTags

        const filteredldTags = oldTags.map(tag =>
          tag.tagId === updatedTag.tagId ? updatedTag : tag
        )

        draft.avaiableTags = [...filteredldTags]

        draft.loadingSavingTag = false

        break
      }

      case `${types.UPDATE_TAG}_REJECTED`: {
        draft.loadingSavingTag = false

        break
      }

      // Delete tag
      case types.DELETE_TAG_OPTIMISTIC: {
        const deletedId = action.payload
        const oldTags = draft.avaiableTags

        const filteredldTags = oldTags.map(tag =>
          tag.tagId !== deletedId
            ? tag
            : { ...tag, deleted: true, saving: true }
        )

        draft.avaiableTags = [...filteredldTags]

        break
      }

      case `${types.DELETE_TAG}_FULFILLED`: {
        const oldTags = draft.avaiableTags

        const filteredldTags = oldTags.filter(tag => !tag?.deleted)

        draft.avaiableTags = [...filteredldTags]

        break
      }

      case `${types.DELETE_TAG}_REJECTED`: {
        const oldTags = draft.avaiableTags

        const filteredldTags = oldTags.map(tag =>
          tag.deleted ? { ...tag, deleted: false, saving: false } : tag
        )

        draft.avaiableTags = [...filteredldTags]
        break
      }

      // Get tags

      case `${types.GET_AVAIABLE_TAGS}_PENDING`: {
        draft.loadingTags = true
        break
      }

      case `${types.GET_AVAIABLE_TAGS}_FULFILLED`: {
        draft.avaiableTags = action.payload
        draft.loadingTags = false
        break
      }

      case `${types.GET_AVAIABLE_TAGS}_REJECTED`: {
        draft.loadingTags = true
        break
      }

      // Update chat tags
      case types.UPDATE_CHATS_TAGS_OPTIMISTIC: {
        const { sessionIds, tags } = action.payload

        const oldChats = draft.chats
        const openChat = draft.selectedChat

        sessionIds.forEach(sessionId => {
          if (sessionId) {
            const selectedChat = oldChats.findIndex(
              item => item.session?.sessionId === sessionId
            )

            draft.chats[selectedChat] = {
              ...draft.chats[selectedChat],
              session: { ...draft.chats[selectedChat].session, tags }
            }

            if (sessionId === openChat?.session.sessionId) {
              draft.selectedChat = {
                ...openChat,
                session: { ...openChat.session, tags }
              }
            }
          }
        })

        break
      }

      case types.UPDATE_CHATS_TAGS: {
        draft.chatsSelectedToEdit = []
        draft.selectChatsMode = false
        draft.chatMenuOpen = null
        draft.selectedTags = []
        draft.shouldRefreshChats = true

        break
      }

      case types.SET_SELECTED_TAG: {
        const { tagId, initialData } = action.payload
        const { selectedTags } = draft

        const tagIsSelected = selectedTags.indexOf(tagId)

        if (tagIsSelected > -1) {
          selectedTags.splice(tagIsSelected, 1)
          draft.selectedTags = selectedTags

          break
        }

        if (initialData) {
          const uniqueArray = [...new Set([...selectedTags, ...initialData])]
          draft.selectedTags = uniqueArray
        }

        if (tagId) {
          draft.selectedTags = [...selectedTags, tagId]
        }

        break
      }

      /**
       * CHATS STATUS BOT
       */
      case `${types.TOGGLE_BOT_STATUS}_PENDING`:
        draft.updateChatLoading = true
        break

      case `${types.TOGGLE_BOT_STATUS}_FULFILLED`: {
        const session = action.payload

        const selectedChat = draft.chats.findIndex(
          item => item.chatId === session.chatId
        )

        draft.selectedChat = selectedChat

        draft.updateChatLoading = false
        draft.shouldRefreshChats = false

        break
      }

      case `${types.TOGGLE_BOT_STATUS}_REJECTED`:
        draft.updateChatLoading = false
        draft.error = action.payload
        break

      /**
       * CHATS STATUS BOT OPTIMISTIC
       */
      case types.TOGGLE_BOT_STATUS_OPTIMISTIC: {
        const {
          chatId,
          data: { botActive }
        } = action.payload

        const oldChats = draft.chats

        const selectedChat = oldChats.findIndex(item => item.chatId === chatId)

        draft.chats[selectedChat] = {
          ...draft.chats[selectedChat],
          session: {
            ...draft.chats[selectedChat].session,
            botActive
          }
        }

        break
      }

      /**
       * Novo Filtro dos chats(abas)
       */
      case types.NEW_FILTER_CHATS_BY_STATUS: {
        draft.selectedStatus = action.payload
        // draft.shouldRefreshChats = true
        // draft.chats = []
        // draft.chatsLength = 0
        // draft.currentPage = 1
        // draft.pages = 1
        break
      }

      /**
       * CHATS STATUS BOT OPTIMISTIC
       */

      case types.SET_SELECTED_TEMPLATE:
        reducerCases[`${types.SET_SELECTED_TEMPLATE}`]({ draft, action })
        break

      case types.RESET_SELECTED_TEMPLATE:
        reducerCases[`${types.RESET_SELECTED_TEMPLATE}`]({ draft })
        break

      /**
       * Iniciar atendimento
       */
      case `${types.START_SERVICE}_PENDING`:
        draft.startServiceLoading = true
        break

      case `${types.START_SERVICE}_FULFILLED`: {
        draft.startServiceData = action.payload

        draft.selectedChat = {
          ...draft.selectedChat,
          session: { ...draft.selectedChat.session, ...action.payload }
        }

        const chats = draft.chats

        const newChat = chats.map(chat =>
          chat.chatId === action.payload.chatId
            ? {
                ...chat,
                session: {
                  ...chat.session,
                  ...draft.selectedChat.session,
                  ...action.payload
                }
              }
            : chat
        )

        draft.selectedStatus = 'in_contact'

        draft.chats = newChat

        draft.startServiceLoading = false
        break
      }

      case `${types.START_SERVICE}_REJECTED`:
        draft.startServiceLoading = false
        draft.error = action.payload
        break

      /**
       * Finalizar atendimento
       */
      case `${types.FINISH_SERVICE}_PENDING`:
        draft.finishServiceLoading = true
        break

      case `${types.FINISH_SERVICE}_FULFILLED`: {
        draft.finishServiceData = action.payload

        draft.selectedChat = {
          ...draft.selectedChat,
          session: { ...draft.selectedChat.session, ...action.payload }
        }
        draft.selectedStatus = 'finished'
        draft.finishServiceLoading = false
        break
      }

      case `${types.FINISH_SERVICE}_REJECTED`:
        draft.finishServiceLoading = false
        draft.error = action.payload
        break
      // Set message status read
      case `${types.SET_NEW_MESSAGE_STATUS_READ}_FULFILLED`: {
        draft.shouldRefreshChats = true

        draft.selectedChat = {
          ...draft.selectedChat,
          unreadMessage: false,
          unreadMessageCount: 0
        }

        break
      }

      /**
       * Listar atendentes
       */
      case `${types.LIST_ATTENDANT}_PENDING`:
        draft.listAttendantLoading = true
        break

      case `${types.LIST_ATTENDANT}_FULFILLED`: {
        draft.listAttendantData = action.payload

        draft.listAttendantLoading = false
        break
      }

      case `${types.LIST_ATTENDANT}_REJECTED`:
        draft.listAttendantLoading = false
        draft.listAttendantError = action.payload
        break

      /**
       * Transferir agente
       */
      case `${types.AGENT_TRANSFER}_PENDING`:
        draft.agentTransferLoading = true
        break

      case `${types.AGENT_TRANSFER}_FULFILLED`: {
        draft.agentTransferData = action.payload

        const agentSelected = action.values

        if (agentSelected) {
          draft.selectedChat = {
            ...draft.selectedChat,

            session: {
              ...draft.selectedChat.session,
              ...action.payload,
              userName: agentSelected.user[0].name
            }
          }
          const chats = draft.chats

          const newChat = chats.map(chat =>
            chat.chatId === agentSelected.chatId
              ? {
                  ...chat,
                  session: {
                    ...chat.session,
                    userName: agentSelected.user[0].name
                  }
                }
              : chat
          )

          draft.chats = newChat
        } else {
          draft.selectedChat = {
            ...draft.selectedChat,
            session: { ...action.payload }
          }

          draft.selectedStatus = 'waiting_contact'
        }

        draft.agentTransferLoading = false
        break
      }

      case `${types.AGENT_TRANSFER}_REJECTED`:
        draft.agentTransferLoading = false
        draft.error = action.payload
        break

      case `${types.HISTORY_CHAT}_PENDING`:
        draft.historyChatLoading = true
        break

      case `${types.HISTORY_CHAT}_FULFILLED`: {
        draft.historyChat = action.payload

        draft.historyChatLoading = false

        break
      }

      case `${types.HISTORY_CHAT}_REJECTED`:
        draft.historyChatLoading = false
        draft.error = action.payload
        break

      default:
    }
  })
}
